<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Todos los Distribuidores</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>

        <div>
          <base-input v-model="mixSearchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"></base-input>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
        <el-table-column label="Nombre" min-width="130px" prop="name" sortable>
          <template #default="{ row }">
            <span>{{ row.name }}</span>

            <div v-if="row.user">
              Usuario: <span class="font-weight-bold">{{ row.user.name }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Asesor Técnico" min-width="130px" prop="seller">
          <template #default="{ row }">
            <div v-if="row.seller">
              <router-link
                v-if="$can('show', 'sellers')"
                :to="{ name: 'SellerShow', params: { id: row.sellerId } }"
                class="h5"
              >
                {{ row.seller.name }}
              </router-link>
              <span v-else class="h5">{{ row.seller.name }}</span>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>

        <el-table-column label="Email" min-width="110px" prop="email">
          <template #default="{ row }">
            <div>
              <a :href="`mailto:${row.email}`">
                {{ row.email }}
              </a>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Localidad" min-width="110px" prop="address">
          <template #default="{ row }">
            <div v-if="row.city">{{ row.city.name }}, {{ row.city.province.name }}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>

        <el-table-column label="Última visita" min-width="110px" prop="lastVisit">
          <template #default="{ row }">
            <div class="text-center">
              <small v-if="row.lastVisit">
                {{ row.lastVisit.visitDate | date }}
              </small>
              <small v-else> - </small>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="" min-width="110px" prop="visitsCount">
          <template #default="{ row }">
            <div>
              <badge type="danger"> {{ row.visitsCount }} visitas </badge>
            </div>
            <div>
              <badge type="default"> {{ row.documentsCount }} archivo{{ row.documentsCount == 1 ? '' : 's' }} </badge>
            </div>
            <div>
              <badge type="primary">
                {{ row.producersCount }} productor{{ row.producersCount == 1 ? '' : 'es' }}
              </badge>
            </div>
            <div>
              <badge type="success"> {{ row.plotsCount }} lote{{ row.plotsCount == 1 ? '' : 's' }} </badge>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="right" label="" min-width="140px">
          <div slot-scope="{ row }" class="d-flex">
            <router-link
              v-if="$can('show', 'distributors')"
              :to="{ name: 'DistributorShow', params: { id: row.id } }"
              class="btn base-button btn-outline-info btn-sm"
            >
              <i class="fas fa-eye"></i>
            </router-link>
            <router-link
              v-if="$can('update', 'distributors')"
              :to="{ name: 'DistributorEdit', params: { id: row.id } }"
              class="btn base-button btn-outline-primary btn-sm"
            >
              <i class="fas fa-pen"></i>
            </router-link>
            <button
              v-if="$can('destroy', 'distributors')"
              class="btn base-button btn-outline-danger btn-sm"
              @click="deleteRow(row.id)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">
          Mostrando {{ from + 1 }} a {{ to }} de un total de {{ pagination.total }} distribuidores
        </p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :show-first-page-button="true"
        :show-last-page-button="true"
        :total="pagination.total"
        class="pagination-no-border"
        @input="changePage"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationOnServerMixin from '@/mixins/paginationOnServerMixin';
import DeleteRowFromTableMixin from '../../../mixins/deleteRowFromTableMixin';

export default {
  name: 'DistributorsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [PaginationOnServerMixin, DeleteRowFromTableMixin],
  data() {
    return {
      tableData: [],
      modelName: 'distributor',
    };
  },

  created() {
    this.defaultSort = 'name';
    this.fetchTableData();

    // configuracion para el alert de eliminar
    this.alertSettings.title = 'Se eliminará el distribuidor';
    this.alertSuccessSettings.message = 'El distribuidor ha sido eliminado';
    this.resourceName = 'distributors';
  },

  methods: {
    fetchTableData() {
      this.pagination.perPage = this.perPage || this.pagination.perPage;
      this.pagination.currentPage = this.page || this.pagination.currentPage;

      const params = {
        'filter[search]': this.mixSearchQuery,
        append: ['lastvisit', 'plotscount'],
        include: ['city.province', 'user', 'visitsCount', 'documentsCount', 'producersCount', 'seller'],
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage,
      };

      this.$services
        .resource('distributors')
        .get(params)
        .then((res) => {
          this.setMeta(res.data.meta);
          return res.data.data;
        })
        .then((data) => (this.tableData = data.distributors));
    },
  },
};
</script>

<style scoped>
div.el-table .el-table__header .cell,
::v-deep div.el-table .el-table__row .cell {
  word-break: keep-all;
}
</style>
